// TODO: Fix all eslint warnings

class CookieService {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public set(name: string, value: string, options: Record<string, any>): void {
        options = {
            path: "/",
            ...options
        };

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (const optionKey in options) {
            updatedCookie += "; " + optionKey;

            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const optionValue = options[optionKey];

            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    public get(name: string): string | null {
        const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
        return matches ? decodeURIComponent(matches[1]) : null;
    }
}

export const cookieService = new CookieService();
